/* NH rails: one input layer for every sideways scroller (draft theme). Loaded once from snippets/nh-site-fixes.
   Owner, 2026-09-29: "the chip row can't be scrolled with a mouse or trackpad". A native overflow-x rail only
   answers a sideways gesture; a mouse wheel (vertical) passed straight through to the page.
   For each rail ([data-nh-rail], .nhi-rail, .nhp-chips__list):
   - Wheel: a vertical wheel over the rail scrolls it sideways, but only while the rail can still move that
     way and only for a gesture that STARTED over the rail. At either end, or mid page-scroll, the page scrolls.
   - Trackpad: native sideways swipe is untouched (no preventDefault on horizontal deltas).
   - Click-drag with a mouse (a drag never fires the link underneath).
   - Prev/next arrows (44px) where the section has none, shown for fine pointers; disabled at the ends.
   - Edge state classes (nhr-start / nhr-end) drive the edge fades, and a progress bar where there is none.
   - Collection chips: one rail at every width (owner, 2026-09-29); arrows page by 80% of the visible width.
   Snap is paused while a wheel or drag moves the rail, so small deltas are never snapped back. */
(function () {
  if (window.__nhRails) return;
  window.__nhRails = true;
  var doc = document;
  var SEL = '[data-nh-rail], .nhi-rail, .nhp-chips__list';
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var lastPageWheel = 0;
  var lastPageDir = 0;

  /* A wheel gesture that began on the page stays with the page (browser-style latching): without this,
     scrolling down the page would stall as soon as the pointer crossed a rail. */
  window.addEventListener('wheel', function (e) {
    if (!e.target.closest || !e.target.closest('.nhr-on')) { lastPageWheel = e.timeStamp; lastPageDir = e.deltaY > 0 ? 1 : e.deltaY < 0 ? -1 : lastPageDir; }
  }, { passive: true, capture: true });

  function px(e, el) { return e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? el.clientWidth : 1; }
  function max(el) { return Math.max(0, el.scrollWidth - el.clientWidth); }

  function svg(dir) {
    return '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="' +
      (dir < 0 ? 'M11 4 6 9l5 5' : 'M7 4l5 5-5 5') +
      '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function bind(el) {
    if (el.__nhr) return;
    el.__nhr = true;
    el.classList.add('nhr-on');
    var sec = el.closest('.shopify-section') || el.parentElement;
    var label = el.getAttribute('aria-label') || (el.closest('nav') && el.closest('nav').getAttribute('aria-label')) || 'items';
    /* data-nh-rail="input": the rail already draws its own arrows and progress (e.g. the cart's "Pairs well
       with"); it only gets the wheel, drag and snap behaviour, with no DOM changes. Gift sets hides ours in CSS from 990px. */
    var inputOnly = el.getAttribute('data-nh-rail') === 'input';
    var ownArrows = inputOnly;
    var ownBar = el.nextElementSibling && el.nextElementSibling.classList.contains('nhi-rail__bar') ? el.nextElementSibling : null;

    /* Frame: rail + (its existing bar) + arrows/bar we add. The existing bar stays the rail's next sibling. */
    var frame;
    if (inputOnly) {
      frame = el.parentElement; /* no DOM changes: only the classes below */
    } else {
      frame = doc.createElement('div');
      frame.className = 'nhr-frame';
      el.parentNode.insertBefore(frame, el);
      frame.appendChild(el);
      if (ownBar) frame.appendChild(ownBar);
    }

    var prev = null;
    var next = null;
    if (!ownArrows) {
      var mk = function (dir) {
        var b = doc.createElement('button');
        b.type = 'button';
        b.className = 'nhr-arrow nhr-arrow--' + (dir < 0 ? 'prev' : 'next');
        b.setAttribute('aria-label', (dir < 0 ? 'Previous ' : 'Next ') + label);
        b.innerHTML = svg(dir);
        b.addEventListener('click', function () { page(dir); });
        frame.appendChild(b);
        return b;
      };
      prev = mk(-1);
      next = mk(1);
    }
    var bar = null;
    if (!ownBar && !inputOnly) {
      bar = doc.createElement('div');
      bar.className = 'nhr-bar';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span></span>';
      frame.appendChild(bar);
    }

    var isChips = el.classList.contains('nhp-chips__list');
    var chipNav = isChips ? el.closest('.nhp-chips') : null;
    function page(dir) {
      var item = el.querySelector(':scope > li, :scope > * > li') || el.firstElementChild;
      var step = el.clientWidth * 0.8;
      if (item && !isChips) {
        var w = item.getBoundingClientRect().width + 12;
        step = Math.max(w, Math.floor((el.clientWidth - 40) / w) * w);
      }
      el.scrollBy({ left: dir * step, behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    var raf = 0;
    function state() {
      raf = 0;
      var m = max(el);
      var sl = Math.abs(el.scrollLeft);
      var scrollable = m > 2;
      frame.classList.toggle('nhr-scrollable', scrollable);
      if (chipNav) chipNav.classList.toggle('nhp-chips--fits', !scrollable);
      el.classList.toggle('nhr-start', sl <= 2);
      el.classList.toggle('nhr-end', sl >= m - 2);
      if (prev) { prev.disabled = !scrollable || sl <= 2; next.disabled = !scrollable || sl >= m - 2; }
      if (bar) {
        var v = el.scrollWidth ? Math.min(1, el.clientWidth / el.scrollWidth) : 1;
        bar.style.setProperty('--v', v.toFixed(3));
        bar.style.setProperty('--p', m ? Math.min(1, sl / m).toFixed(3) : '0');
      }
    }
    function queue() { if (!raf) raf = requestAnimationFrame(state); }
    el.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (window.ResizeObserver) new ResizeObserver(queue).observe(el);
    state();

    /* Once a wheel, trackpad or mouse drag moves the rail, snapping stays off for this rail: re-enabling it
       re-snapped a rail parked at its end back to the last card, so the next notch was eaten by the rail
       instead of scrolling the page. Touch keeps snap (these events never fire for touch). */
    function pauseSnap() { el.classList.add('nhr-free'); }

    var lastMapped = -1e9;
    function scroller(node) {
      for (var n = node.parentElement; n && n !== doc.body && n !== doc.documentElement; n = n.parentElement) {
        var cs = getComputedStyle(n);
        if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && n.scrollHeight > n.clientHeight + 1) return n;
        /* Inside a drawer/dialog with nothing left to scroll: never move the page behind it. */
        if (cs.position === 'fixed' || n.tagName === 'DIALOG' || n.getAttribute('aria-modal') === 'true') return null;
      }
      return window;
    }
    /* Wheel: vertical → sideways only while the rail can move that way. */
    el.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.defaultPrevented) return;
      var dx = e.deltaX * px(e, el);
      var dy = e.deltaY * px(e, el);
      if (Math.abs(dx) >= Math.abs(dy)) { if (dx) pauseSnap(); return; } /* trackpad sideways: native */
      var m = max(el);
      if (m <= 2) return;
      var sl = el.scrollLeft;
      var left = dy > 0 ? m - sl : sl;
      var dir = dy > 0 ? 1 : -1;
      /* A gesture that started on the page (or was handed to it at the rail's end) stays with the page, but
         only in the same direction: reversing the wheel over a rail parked at its end scrolls the rail back
         (wheel up = left until scrollLeft is 0, then the page). */
      var pageOwns = e.timeStamp - lastPageWheel < 350 && dir === lastPageDir;
      if (pageOwns || left < 16) {
        /* at (or a snap-width from) the end: finish the rail and let the page scroll */
        if (!pageOwns && left > 0.5) el.scrollBy({ left: dy > 0 ? left : -left, behavior: 'instant' });
        /* Chrome keeps a wheel sequence we were handling latched to the rail for a moment, so the first
           notches after the end moved nothing. Inside that window we move the page (or the scrolling panel
           the rail sits in) ourselves; outside it the browser scrolls natively. */
        if (e.timeStamp - lastMapped < 1200) {
          e.preventDefault();
          lastMapped = e.timeStamp;
          lastPageWheel = e.timeStamp;
          lastPageDir = dir;
          var box = scroller(el);
          if (box) box.scrollBy({ top: dy, behavior: 'instant' });
        }
        return;
      }
      e.preventDefault();
      lastMapped = e.timeStamp;
      pauseSnap();
      el.scrollBy({ left: dy, behavior: 'instant' });
    }, { passive: false });

    /* Click-drag with a mouse. */
    var dragging = false;
    var startX = 0;
    var startSL = 0;
    var moved = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || max(el) <= 2) return;
      dragging = true; moved = 0; startX = e.clientX; startSL = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var d = e.clientX - startX;
      if (!moved && Math.abs(d) < 6) return;
      if (!moved) { el.classList.add('nhr-free', 'nhr-dragging'); try { el.setPointerCapture(e.pointerId); } catch (_) {} }
      moved = Math.abs(d);
      el.scrollLeft = startSL - d;
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      el.classList.remove('nhr-dragging');
      pauseSnap();
      if (moved >= 6) {
        /* swallow the click that ends a drag, so a drag over a link doesn't open it */
        el.addEventListener('click', function stop(ev) { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
        setTimeout(function () { moved = 0; }, 0);
      }
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    el.addEventListener('dragstart', function (e) { if (dragging) e.preventDefault(); });

    /* Keyboard: a focused chip/card is brought fully into view (not half under the fade). */
    el.addEventListener('focusin', function (e) {
      var t = e.target.closest('li') || e.target;
      if (t === el) return;
      var r = t.getBoundingClientRect();
      var b = el.getBoundingClientRect();
      if (r.left < b.left + 32 || r.right > b.right - 32) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce.matches ? 'auto' : 'smooth' });
    });

    return { state: state };
  }

  function init() {
    doc.querySelectorAll(SEL).forEach(bind);
    /* bring the current collection chip into view on phones */
    var cur = doc.querySelector('.nhp-chips__list [aria-current="page"]');
    if (cur) {
      var list = cur.closest('.nhp-chips__list');
      if (list.scrollWidth > list.clientWidth + 2) {
        var li = cur.closest('li');
        if (li.offsetLeft + li.offsetWidth > list.clientWidth - 48) list.scrollLeft = li.offsetLeft - 16;
      }
    }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', init);
  /* Rails rendered later (cart drawer upsells, recommendations) opt in with data-nh-rail and nh:rails:scan. */
  doc.addEventListener('nh:rails:scan', init);
  window.nhRails = { scan: init };
})();
